import { StatusChip } from '@/components/Shared/StatusChip';
import type { ProductRegistryStatus } from '@/types/productRegistry';

interface ProductStatusChipProps {
  status: ProductRegistryStatus;
  label: string;
}

export function ProductStatusChip({ status, label }: ProductStatusChipProps) {
  return <StatusChip label={label} variant={status} />;
}
